import React, {useState, useEffect} from "react";
import {ConfigProvider, App as AntdApp} from 'antd';
import axios from "axios";
import Light from './themes/light';
import Dark from './themes/dark';
import './styles/app.css'
import {LoadingOutlined} from '@ant-design/icons';
// components
import PaymentInfo from './components/PaymentInfo'
import EmptyData from './components/PaymentInfo/emptyData'

function App() {
    const [themeColor, setThemeColor] = useState('light')
    const [load, setLoad] = useState(true);
    const [data, setData] = useState(null);
    const [intervalId, setIntervalId] = useState(null);

    const getData = (uuid) => {
        try {
            axios({
                withCredentials: false,
                method: 'get',
                url: `${process.env.REACT_APP_API_URL}${uuid}`
            }, {}).then(r => {
                setData(r?.data);
                setLoad(false);
            }).catch(err => {
                console.log('error: ', err);
                setLoad(false);
                clearInterval(intervalId);
                setIntervalId(null);
            })
        } catch (err) {
            console.log('error: ', err);
            setLoad(false);
        }
    }

    const gatDataInterval = (uuid) => {
        if (intervalId) return;

        const i = setInterval(() => {
            getData(uuid);
        }, 5000);

        setIntervalId(i);
    }

    useEffect(() => {
        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        }
    }, [intervalId]);

    useEffect(() => {
        const {pathname} = window.location;
        const uuid = pathname?.split('&')[0].substring(1);
        const params = new URLSearchParams(pathname?.split('&')[1]);
        const theme = params.get('theme');

        if (theme) {
            setThemeColor(theme)
        }

        getData(uuid);
        gatDataInterval(uuid);
        return () => {
            clearInterval(intervalId);
            setIntervalId(null);
        }
    }, []);

    return (
        <ConfigProvider theme={themeColor === 'dark' ? Dark : Light}>
            <AntdApp
                className={themeColor === 'dark' ? 'darkThemeApp' : 'lightThemeApp'}
                style={{
                    backgroundColor: themeColor === 'dark' ? '#1A1A1A' : '#e9e9e9',
                    transition: 'background-color 0.3s ease',
                }}>

                {load ?
                    <LoadingOutlined style={{fontSize: '23px'}}/> :
                    <> {data ? <PaymentInfo data={data} themeColor={themeColor}/> :
                        <EmptyData themeColor={themeColor}/>}
                    </>}
            </AntdApp>
        </ConfigProvider>
    );
}

export default App;
